import React, { FC } from 'react'
import { useReactiveVar } from '@apollo/client'
import { labelTitleVar } from 'modulesCommon/store'

import { useZoneMenu } from 'modulesCommon/serviceHooks'
import { MostViewed } from 'modules/Feed/components'
import useGetMostViewedProjects from 'modules/Feed/serviceHooks/useGetMostViewedProjects'

const MostViewedProjects: FC = () => {
  const { currentSpace } = useZoneMenu()
  const { mostViewedProjects } = useGetMostViewedProjects()
  const currentLabelTitle = useReactiveVar(labelTitleVar)

  if ((!currentSpace?.name && !currentLabelTitle) ||!mostViewedProjects?.length) {
    return null
  }

  return (
    <MostViewed
      title={currentSpace?.name || currentLabelTitle}
      mostViewedProjects={mostViewedProjects}
      isSpace={!!currentSpace}
    />
  )
}

export default MostViewedProjects
